import { api, makeApiRequest } from '../_init'

// Facebook OAuth/token-exchange flow — split out of connect/meta.js (which
// used to bundle this with asset listing/enrichment) when the asset side
// moved to domain/integrationAssets. Unrelated to the v3->v4 asset migration;
// left as-is.
const metaAuthorizationApi = {
  postAuthorizationCode: async (code) => {
    return await makeApiRequest(api, 'post', '/integrations/connect/facebook/authorize', code, {
      timeout: 0,
    })
  },
  postAccessToken: async (accessToken) => {
    return await makeApiRequest(
      api,
      'post',
      '/integrations/connect/facebook/token',
      {
        access_token: accessToken,
      },
      { timeout: 0 },
    )
  },
  getStatus: async () => {
    return await makeApiRequest(api, 'get', '/integrations/connect/facebook/status')
  },
  getTokenStatus: async (tokenId) => {
    return await makeApiRequest(
      api,
      'get',
      `/integrations/connect/facebook/token-status/${tokenId}`,
    )
  },
  deactivate: async (tokenType, platformUserId) => {
    return await makeApiRequest(api, 'delete', '/integrations/connect/facebook/token', {
      token_type: tokenType?.toUpperCase(),
      platform_user_id: platformUserId,
    })
  },
  getPartnerToken: async (code, redirectUri) => {
    return await makeApiRequest(
      api,
      'post',
      `/vendor/partners/tokens?code=${code}&redirect_uri=${redirectUri}`,
    )
  },
  pollTaskStatus: async (taskId) => {
    return await makeApiRequest(api, 'get', `/tasks/${taskId}`)
  },
}

export default metaAuthorizationApi
